import nBossConnection from 'modules/base/service/nBossConnection';
import FuseLoading from '@fuse/core/FuseLoading';
import { useState, useEffect } from 'react';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import FmBrowserTableService from 'app/admin/fileManager/service/FmBrowserTableService';
import { withRouter, useParams } from 'react-router';
import TableFilterListDto from 'modules/base/dto/table/TableFilterListDto';

const config = data => {
	return {
		key: 'fmBrowserTable',
		text: data.current.parentStorage.fileName + (data.current.fileName != null ? ` - ${data.current.fileName}` : ''),
		textKey: 'fm-browser',
		service: FmBrowserTableService,
		editFormState: item => (item != null && item.fileCategory === 'Directory' ? `/fm-browser/dir/${data.directory}/${data.storage}/${item.id}` : `/fm-browser/edit/${data.directory}/${data.storage}/${item ? item.id : 'new'}`),
		editDirState: item => `/fm-browser/dir/${data.directory}/${data.storage}/${item ? item.id : 'new'}`,
		fileOpenState: item => `${nBossConnection.baseUrl}/fmFileEditControl/getFile?key=${item.key}`,
		toolbarAction: ['search', 'refresh', 'newDir', 'newFile'],
		rowEndAction: ['fileOpen', 'modify', 'delete'],
		backLink: () => {
			if (data.directory === 0) {
				return '/fm-storage';
			}
			return `/fm-browser/${data.current.parentDirectory != null ? data.current.parentDirectory.id : '0'}/${data.storage}`;
		},
		rowClick: item => {
			if (item.fileCategory === 'Directory') return `/fm-browser/${item.id}/${data.storage}`;
			return `${nBossConnection.baseUrl}/fmFileEditControl/getFile?key=${item.key}`;
		},
		rowClickTarget: item => {
			if (item.fileCategory === 'Directory') return '_self';
			return '_blank';
		},
		defaultFilter: () => {
			return new TableFilterListDto().setup({
				list: [
					{
						propertyName: 'parentStorage',
						type: 'EQ',
						value: data.storage,
						permanent: true
					},
					{
						propertyName: 'parentDirectory',
						type: data.directory !== 0 ? 'EQ' : 'IS_NULL',
						value: data.directory !== 0 ? data.directory : true,
						permanent: true
					}
				],
				activeCount: 2
			});
		},
		columns: [
			{
				key: 'fileCategory',
				text: '',
				textKey: 'fileCategory',
				type: 'iconFileType',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'fileName',
				text: 'Név',
				textKey: 'fileName',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'fileModified',
				text: 'Módosítva',
				textKey: 'fileModified',
				type: 'dateTime',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'fileSize',
				text: 'Méret',
				textKey: 'fileSize',
				type: 'fileSize',
				sortable: true,
				disablePadding: false
			}
		]
	};
};

function FmBrowserTable() {
	const { directory, storage } = useParams();
	const [current, setCurrent] = useState(null);

	useEffect(() => {
		setCurrent(null);
		FmBrowserTableService.getCurrent(directory !== '0' ? directory : null, storage).then(response => setCurrent(response));
	}, [directory, storage]);

	if (current === null) {
		return <FuseLoading />;
	}

	const myConfig = config({
		storage: parseInt(storage, 10),
		directory: parseInt(directory, 10),
		current
	});
	return <TableBrowser config={myConfig} />;
}

export default withRouter(withReducer('fmBrowserTable', reducer('fmBrowserTable'))(FmBrowserTable));
